import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ManageAccountsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"manage_accounts"}/>
}
